<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <b-tabs pills justified content-class="p-3 text-muted mx-4">
          <b-tab class="border-0" :active="tabIndex === 'order'" @click="tabSelectFn('order')">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Automated Statements</span>
            </template>
            <div class="p-4">
              <TableLoading v-if="scheduledStatementOrders.page === 0"/>
              <div v-else>
                <data-table :columns="automatedStatementColumns" :rows="scheduledStatementOrders.objects" :has-pagination="false" @onSearch="searchFn">
                  <template v-slot:actions="slotProps" v-if="checkForPermission(view_single_order_permission)">
                    <b-button variant="info" size="sm" class="py-1 text-white" @click="viewStatementInvoice(slotProps.row.order.publicId)">
                      View Invoice
                    </b-button>
                  </template>
                </data-table>
                <b-pagination
                    v-model="statementsCurrentPage"
                    :total-rows="scheduledStatementOrders.total"
                    :per-page="perPage"
                    size="lg"
                    align="center"
                    class="mt-3"
                />
              </div>
            </div>
          </b-tab>
          <b-tab :active="tabIndex === 'emails'" @click="tabSelectFn('emails')">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Processed Emails</span>
            </template>
            <div class="p-4">
              <TableLoading v-if="processedStatementEmails.page === 0"/>
              <div v-else>
                <data-table :columns="processedEmailsColumns" :rows="processedStatementEmails.objects" :has-pagination="false" @onSearch="searchEmailFn">
                  <template v-slot:actions="slotProps" v-if="checkForPermission(view_email_statement_details)">
                    <b-button variant="info" size="sm" class="py-1 text-white" @click="viewDetails(slotProps.row.publicId)">
                      View Details
                    </b-button>
                  </template>
                </data-table>
                <b-pagination
                    v-model="emailCurrentPage"
                    :total-rows="processedStatementEmails.total"
                    :per-page="perPage"
                    size="lg"
                    align="center"
                    class="mt-3"
                />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import DataTable from "@/components/data-table";
import {ALL_AUTOMATED_STATEMENTS, ALL_PROCESSED_EMAILS} from "@/gql/finance";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Automated Statements",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "automated-statements",
  data() {
    return {
      title: "Automated Statements",
      selectedTab: '',
      tabIndex: 'order',
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Automated Statements",
          active: true
        }
      ],
      view_single_order_permission: permissions.view_single_order_permission,
      view_email_statement_details: permissions.view_email_statement_details,
      automatedStatementColumns: [
        {
          field: 'customerId.name',
          label: 'Customer'
        },
        {
          field: 'order.invoiceId',
          label: 'Invoice ID'
        },
        {
          field: 'order.orderedBy',
          label: 'Ordered By'
        },
        {
          field: 'order.deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'statementTotal',
          label: 'Order Total'
        },
        {
          field: 'statementPaymentDue',
          label: 'Expected Payment Date'
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      statementsCurrentPage: 1,
      perPage: 30,
      statementsSearchKeyword: "",
      scheduledStatementOrders: {
        page: 0,
        objects:[]
      },
      processedEmailsColumns: [
        {
          field: 'statementNumber',
          label: 'Statement ID'
        },
        {
          field: 'customerId.name',
          label: 'Customer'
        },
        {
          field: 'emailTo',
          label: 'Email To'
        },
        {
          field: 'createdAt',
          label: 'Statement Processed At'
        },
        {
          field: 'emailDeliveryStatus',
          label: 'Statement Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      emailCurrentPage: 1,
      emailSearchKeyword: "",
      processedStatementEmails: {
        page: 0,
        objects: []
      }
    }
  },
  apollo: {
    scheduledStatementOrders: {
      query: ALL_AUTOMATED_STATEMENTS,
      variables(){
        return {
          page: this.statementsCurrentPage,
          perPage: this.perPage,
          searchKeyword: this.statementsSearchKeyword,
        }
      }
    },
    processedStatementEmails: {
      query: ALL_PROCESSED_EMAILS,
      variables(){
        return {
          page: this.emailCurrentPage,
          perPage: this.perPage,
          searchKeyword: this.emailSearchKeyword,
        }
      }
    }
  },
  watch: {
    statementsCurrentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    emailCurrentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  methods: {
    viewStatementInvoice(public_id){
      this.$router.push(routeItems.customer_order_invoice_route+'/'+public_id)
    },
    viewDetails(public_id){
      this.$router.push(routeItems.statement_logs_route+'/'+public_id)
    },
    tabSelectFn(index){
      this.$router.replace({...this.$router.currentRoute, query: {tab: index}}).catch(() => {})
    },
    searchFn(data){
      this.statementsSearchKeyword = data
    },
    searchEmailFn(data){
      this.emailSearchKeyword = data
    },
  },
  beforeMount() {
    this.tabIndex = this.$route.query.tab || ""
  }
}
</script>

<style scoped>

</style>
